import { useCallback } from "react";

import { useResultHandler } from "../../../../hooks/useResultHandler";
import { usePublishSurvey } from "./usePublishSurvey";

export const usePublishSurveySubmission = () => {
  const { publishSurvey, loading } = usePublishSurvey();
  const { handleResult, handleError } = useResultHandler();

  const submitPublish = useCallback(
    async (id: string, isPublished: boolean) => {
      try {
        const response = await publishSurvey(id, { is_published: !isPublished });
        const success = handleResult(response, { showSuccessToast: false });
        return { success, response };
      } catch (error: unknown) {
        handleError(error, "An error occurred while updating the survey status");
        return { success: false, response: undefined };
      }
    },
    [handleError, handleResult, publishSurvey],
  );

  return { submitPublish, loading };
};
